import { render, staticRenderFns } from "./DhxGrid.vue?vue&type=template&id=bd8767b2"
import script from "./DhxGrid.vue?vue&type=script&lang=js"
export * from "./DhxGrid.vue?vue&type=script&lang=js"
import style0 from "./DhxGrid.vue?vue&type=style&index=0&id=bd8767b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports